import { Box } from '@mui/material';
import { ReactNode } from 'react';

interface IProps {
  children: ReactNode;
}

function Content({ children }: IProps): React.JSX.Element {
  return (
    <Box
      bgcolor="whitesmoke"
      display="flex"
      flexDirection="column"
      flexGrow={1}
      sx={{ overflowY: 'auto' }}
    >
      {children}
    </Box>
  );
}

export default Content;
